// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"908":"2aa8c8b1","2638":"7e300d9a","5202":"daf2524e","8175":"afe2f7f1"}[chunkId] + ".chunk.css";
};